// Generated by CoffeeScript 2.3.1
let api, callbacks, cmds, done, global_taskid, group_send, queue

global_taskid = 0

api = {
  getMultiple(opts) {
    let count, fields, ids, map, nobatch, tableName
    ;({ tableName, ids, fields, nobatch } = opts)
    count = 0
    map = {}
    ids.map(id => (map[id] = count++))
    return this.find({
      tableName,
      query: {
        _id: {
          $in: ids,
        },
      },
      fields,
      nobatch,
    })
      .then(res => {
        let items
        items = []
        res.map(item => {
          let idx
          idx = map[item._id]
          return (items[idx] = item)
        })
        return items
      })
      .catch(e => console.error(e))
  },
}

queue = []

callbacks = {}

done = true

group_send = _.debounce(() => {
  let send
  if (!done) {
    return
  }
  send = function() {
    let cmd, length, opts, t0
    if (queue.length === 0) {
      return Promise.resolve()
    }
    done = false
    opts = queue.splice(0, 100)
    // queue = []
    t0 = Date.now()
    cmd = 'batch'
    length = -1
    // console.log cmd, opts
    return app
      .service('api')
      .create({ cmd, opts })
      .catch(error => {
        app.error({ cmd, opts, error })
        Promise.reject(error)
        return (done = true)
      })
      .then(res => {
        let cb, data, k, results, taskid, v
        length = JSON.stringify(res).length
        results = []
        for (k in res) {
          v = res[k]
          ;({ taskid, data } = v)
          cb = callbacks[taskid]
          delete callbacks[taskid]
          results.push(cb(data))
        }
        return results
      })
      .then(() => {
        let t
        t = Date.now() - t0
        length = (length / 1024).toFixed(0)
        // console.info "batch #{opts.length}/#{opts.length+queue.length}, l = #{length}k, t = #{t}"
        if (queue.length > 0) {
          return send()
        } else {
          return (done = true)
        }
      })
  }
  return send()
}, 100)

cmds = [
  'findAllDistinct',
  'update',
  'updateMultiple',
  'create',
  'batchCreate',
  'delete',
  'find',
  'findOne',
  'import',
  'doExport',
  'upload',
  'download',
  'preview',
  'preview_masked',
  'deletePreview',
  'search',
  'getProfile',
  'load',
  'parse',
  'buildCV',
  'changePassword',
  'undo',
  'analyze',
  'logs',
  'findCandiByFields',
  'confuse',
  'candidates_loadOChart',
  'candidates_removeOChart',
  'candidates_setOChart',
  'candidates_remove',
  'candidates_findCandiByFields',
  'candidates_match',
  'candidates_findDuplicates',
  'exportReport',
]

// 'mapLists'
// 'handleLists'
cmds.map(
  cmd =>
    (api[cmd] = function(opts) {
      let ref, ref1, ref2, t0
      // opts.stack = new Error().stack.replace(/^.*\n/,'')
      if (((ref = opts.data) != null ? ref[''] : void 0) != null) {
        delete opts.data['']
      }
      if (((ref1 = opts.data) != null ? ((ref2 = ref1.$set) != null ? ref2[''] : void 0) : void 0) != null) {
        delete opts.data.$set['']
      }
      if (
        !opts.nobatch &&
        (cmd === 'find' || cmd === 'update' || cmd === 'delete' || cmd === 'findOne' || cmd === 'create')
      ) {
        return new Promise((resolve, reject) => {
          let taskid
          taskid = global_taskid++
          queue.push({ taskid, cmd, opts })
          callbacks[taskid] = function(res) {
            return resolve(res)
          }
          return group_send()
        })
      } else {
        t0 = Date.now()
        return app
          .service('api')
          .create({ cmd, opts })
          .then(
            res =>
              // console.info cmd, 't = ', Date.now() - t0
              res,
          )
          .catch(error => {
            console.error(error)
            app.error({ cmd, opts, error })
            return Promise.reject(error)
          })
      }
    }),
)

export default api
